export enum PlacementServiceStatusAirtable {
  ToBeFixedByGis = "To be fixed by GIS",
  ToBeProcessedByCs = "To be processed by CS",
  ToBeProcessedByOps = "To be processed by OPS",
  SentToClient = "Sent to Client",
  SentToTAPilotSurveyor = "Sent to TA Pilot/Surveyor",
  ToBeProcessedByGis = "To be processed by GIS",
  ProcessedByGis = "Processed by GIS",
  Cancelled = "Cancelled",
}
